



















import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import UsersService from '@/mixins/users.service';
import FiltersService from '@/mixins/filters.service';
import { User, UserId } from '@/types/user';

@Component({
  mixins: [ UsersService, FiltersService ],
})
export default class UserFilter extends Mixins(UsersService, FiltersService) {

  private onSelectedUsers(users: UserId[]) {
    this.$store.commit('users/setSelected', users);
  }

}
